const productionApiUrl = 'https://admin-siem.zacatecas.gob.mx/api/';
const developmentApiUrl = 'http://localhost:8000/api/';
const currentHostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isLocalHost = ['localhost', '127.0.0.1', '::1'].includes(currentHostname);

export const API_BASE_URL = process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'development' || isLocalHost ? developmentApiUrl : productionApiUrl);

const normalizedApiUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL : `${API_BASE_URL}/`;

export const STORAGE_BASE_URL = process.env.REACT_APP_STORAGE_URL ||
    normalizedApiUrl.replace(/api\/$/, 'storage/');

export const storageUrl = (path) => {
    if (!path) {
        return null;
    }

    if (/^https?:\/\//i.test(path)) {
        return path;
    }

    return `${STORAGE_BASE_URL}${String(path).replace(/^\/+/, '')}`;
};
